import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "agents",
  "use": "agents-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"agents\">\n<path d=\"M4.43652 2.07617H15.5635C15.502 1.30273 15.0449 0.880859 14.2012 0.880859H5.79004C4.95508 0.880859 4.48926 1.30273 4.43652 2.07617ZM2.64355 4.61621H17.3564C17.2334 3.78125 16.8115 3.30664 15.8799 3.30664H4.12012C3.18848 3.30664 2.7666 3.78125 2.64355 4.61621ZM3.68066 20.4189H16.3105C18.1387 20.4189 19.0967 19.4697 19.0967 17.6592V8.80859C19.0967 6.99805 18.1387 6.04883 16.3105 6.04883H3.68066C1.84375 6.04883 0.894531 6.98926 0.894531 8.80859V17.6592C0.894531 19.4697 1.84375 20.4189 3.68066 20.4189ZM10.0088 14.5303C8.54102 14.5127 7.38965 13.291 7.38086 11.6562C7.38086 10.1094 8.54102 8.83496 10.0088 8.83496C11.4854 8.83496 12.6455 10.1094 12.6455 11.6562C12.6455 13.291 11.4941 14.5479 10.0088 14.5303ZM5.0166 18.7578C5.71094 16.9912 7.6709 15.752 10.0088 15.752C12.3555 15.752 14.3154 16.9912 15.0098 18.7578H5.0166Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/agents.svg
// module id = CmA3
// module chunks = 13